export const minWindowWidth = 1280
export const maxWindowWidth = 1600
export const aiAssistantChatButtonCloseEvent = 'ai-assistant-chat-button-close'
export const aiAssistantChatButtonOpenEvent = 'ai-assistant-chat-button-open'
